module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('h1', [_vm._v("Sadie")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-s"
  }, [_vm._v("S")]), _vm._v("ADIE TURNED HER FACE")]), _vm._v(" up to the sun, enjoying the country breeze that blew through her hair.  In the passenger seat of Palmer’s rented convertible, she reveled in the freedom of riding through the French countryside as they headed to Paris.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She wanted to completely put the events of the baking competition far behind her.  Her goal now was to show Palmer a good time in Paris.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You know,” he said as, “you don’t really have to do this Paris thing.  I was kind of kidding when I brought up the idea of you showing me around town.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I know,” Sadie said without opening her eyes.  “But I think it’s a good idea.  It could be fun, and I feel like I need that now.  Besides, I really do want you to see my Parisian bakery.  I’m so proud of it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Okay, good,” he said.  “I just wanted to be clear that I wouldn’t be mad at you if you backed out.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She smiled.  “I know that, Palmer.  Anyway, I know that you can’t get mad at me no matter what.”  She turned to look at him, pulling down her sunglasses to wink at him.  “I’m just too sweet to get mad at.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She shot a quick glance at the back seat.  Her scruffy little terrier, Biscuit, was sitting up straight, taking in as many of the country scents as he could.  Orchid, however, had found herself a cozy and wind-free spot on the floor of the car where she rolled up and catnapped. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Palmer laughed.  “You are indeed too sweet.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Turning back to look out the windshield, she fell in love with the outskirts of Paris.  “Maybe my next bakery will be out here,” she mused.  “Isn’t it just beautiful?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And we’re getting pretty close to the city,” Palmer said.  “The best of both worlds.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie nodded.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Where’s your bakery exactly?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Head for the Eiffel Tower,” she said.  “It’s about three blocks beyond that.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The road became busier and more hurried the closer they got to the center of Paris.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Take Boulevard Pasteur, then turn right onto Vaugirard.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Pasteur, then Vaugirard to the right,” Palmer confirmed.  “Got it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh,” Sadie gushed.  “It’s been a while since I’ve been here.  I do love this city.  There’s more than just romance, great food and beautiful art.  There’s something in the air... an excitement.  That "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("joie de vivre")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What is "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("joie de vivre")]), _vm._v("?” Palmer said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s a joy for life, and it’s unmistakable.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Already as they drove down the narrow streets, Sadie admired the old world architecture, falling in love with the city all over again.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’ll also be great to see everyone.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Looks like a nice neighborhood,” Palmer said as he looked on one side of the street then the other.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I like it,” Sadie said, nodding.  “The moment I found it, I knew this was where I wanted to set up my first French bakery.  Oh!  Here... take a right.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Palmer quickly turned right.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sorry,” Sadie said.  “So caught up in my anticipation, I almost forgot to tell you where to go.”  She pointed to her right.  “Look, just there with the white and sand-colored awning.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("La Croute Doré")]), _vm._v("?” Palmer said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yeah,” Sadie said.  “The Golden Crust.  You don’t like it?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Now that I know what it means, I love it.  Sounds delish.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Palmer parked the car as close as possible to the bakery and killed the engine.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie opened the car door and got out, looking into the backseat to see Biscuit stretched out on the seat while Orchid still snoozed.  “You guys watch the car.  We’ll be back in a minute.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She led the way to the front door of her bakery.  Before opening the door, she took a look inside.  The display in the window was appetizing, just the way she liked it.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Several shelves were filled with tasty goodies and a large basket contained other sweet treats.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("When she pulled back the door, she was assailed by the warm and welcoming aroma of fresh baked brioches, croissants and tartelettes.  “Don’t you just love that smell,” she said with a smile as she walked in.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Bonjour,” the young woman behind the counter called out.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Bonjour, Marie-Eve,” Sadie said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh,” Marie-Eve said as she realized who she was speaking to.  “Mademoiselle Sadie.  How lovely to see you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I apologize for the surprise visit, but I wanted to show the bakery to my friend, Palmer.”  She gestured to Palmer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Bonjour,” Palmer said in a very stilted French.  “Enchanté.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Two customers were at the counter and another one walked in.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ll leave you to tend to your customers,” Sadie said.  “Is it all right if I show my friend around?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Bien sur")]), _vm._v(",” Marie-Eve said with a giggle.  “After all, you are the boss.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie smiled as Marie-Eve turned to her customer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So, what do you think?” Sadie said to Palmer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I love how you made this shop look like your New York place,” Palmer said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Nodding, Sadie perused the various shelves laden with fresh baked goods, and sweet goodies.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I didn’t want to try to be another Parisian pastry shop,” Sadie said.  “I knew I had to do my own thing if I wanted to stand out.  I also wanted to show what we Americans can do with a pastry.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I like that,” Palmer said.  “Bring that New York state of mind to Paris.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That’s right.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Do you have any idea how you’re doing compared to all the other bakeries and pastry shops run by celebrity chef’s around here?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m holding my own,” Sadie said.  “I get weekly updates from here, and our numbers are good.  But, we’re also getting good reviews, and that helps a lot.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Cool,” Palmer said.  “You deserve it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Thing is,” Sadie went on as she looked at the fresh baked pies.  “I’m not competing with those pastry shops on an artistic level.  I mean, if you saw what Chef Angus does... it is a veritable feast for the eyes.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But, I know you, Sadie,” Palmer said.  “I know you have artistic talent.  I’ve seen the things that you make.  They’re so beautiful, you don’t want to eat them.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie smiled.  “Thanks.  I try my best, but in a shop like this, it isn’t always easy.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I see.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Chef Angus’ pastries tend to be the sort of thing that you might buy for a special occasion... unless you have a lot of dough, of course.  If you look at around, you’ll see that all my products are pretty simple.  Tastefully done, but simple.  All that pretty artistry that others build their reputations on cost a lot.  It’s hours of work, which translates to several dollars for just one small bite-sized piece.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I see what you mean.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I wanted to reach the everyday customer,” Sadie said.  “The family that wants a few good croissants for breakfast without breaking the bank.  Or the customer who wants a few tasty pastries for dessert at a reasonable price.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sounds like a good strategy,” Palmer said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Marie-Eve finished with her customers, so Sadie went up to the counter.  “My friend and I would like to have a "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chocolatine, ")]), _vm._v("and could you prepare a small box of mixed pastries to go?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tres bien")]), _vm._v(",” Marie-Eve said.  She picked up the thongs, grabbed two chocolatines and put them into a small paper bag.  Then she took a pastry box and filled it with various treats.  “Voila.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie handed Marie-Eve the money to cover the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chocolatines")]), _vm._v(" and treats plus a little something for the service.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh,” Marie-Eve said.  “"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Non.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Non")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ah,” Sadie insisted.  “"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Oui.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Oui")]), _vm._v(".  I want your books to balance.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Marie-Eve accepted the money.  “Merci.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m very happy with the way things look, Marie-Eve,” Sadie said.  “Keep up the good work.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("“Merci.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("“Au revoir")]), _vm._v(",” Sadie said as she and Palmer headed out.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She handed a "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chocolatine")]), _vm._v(" to Palmer then pulled the second one out of the bag to taste it.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Good,” Palmer said as he finished the pastry in three bites.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So much for savoring,” Sadie said with a smile.  But she then went on to finish her pastry in four quick bites.  “Oh, yeah... this really is good.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Bravo,” Palmer said as they reached the car.  “You really did a great job here.  The shop looks great, smells great and the pastries are irresistible.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie nodded.  “I am pretty proud of it.  To tell you the truth, there was a time there when I didn’t think it would work.  It seemed like everyone disagreed with my vision.  But I pushed through, got things my way, and now...  Well, people around here really seem to appreciate what I’m doing.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Before getting in the car, she pulled a treat out of her purse and reached out to Biscuit.  “Here you go, buddy.  You’re such a good boy.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He delicately took the treat out from her fingertips. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So,” she said as she got in the car.  “What do you want to see next?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Palmer got into the driver’s seat and looked at her with a playful grin.  “What does everyone who comes to Paris want to see?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The Eiffel Tower,” they both said together.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Good idea,” Sadie said as she buckled up.  “Though I’ve passed by it several times, I must admit that I’ve never gone up.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Great,” Palmer said.  “Because I already took the liberty of reserving us a pair of tickets.  I tried to reserve a table at the restaurant high above the lights of Paris, but I was too late.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Giddy, Sadie looked at him.  “For real?  I don’t mind not having dinner up there.  Just going up is going to be cool.  Did you really reserve?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Palmer pulled out his phone to show her the reservations he had.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, but this is not for another four hours,” Sadie said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No worries,” he said.  “We can drive around a bit, see the sights, then head up just as the sun is setting.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sounds good to me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They drove around, admiring the many sights that so many tourists longed to see, but also coming upon places that were not so well known.  They walked down a few of the quaint and romantic streets, rue des Rosiers, rue Lepic and au Vieux Paris.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They roamed "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("through l’Atelier de Lumiere")]), _vm._v(", a museum of lights.  Then got their noses filled with the scents of perfume at the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Musée du Parfum")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Finally, they took a boat ride on the Canal St. Martin, and took in the sites from that perspective.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Do you think we could find a park to let them out?” Sadie said, looking into the backseat at Biscuit and Orchid.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sure thing.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They found a small park and got out to stretch their legs and allow Biscuit and Orchid a chance to walk around a bit.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, this really is nice,” Sadie said as they slowly strolled through the park with Biscuit on a leash and Orchid in Palmer’s arms.  “What a day.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It was certainly more than I expected.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They meandered down the stone path then stopped at a park bench.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“While we’re here,” Sadie said as she pulled two small plastic bags out of her purse.  “I may as well feed them.  They’ll be in the car for another little while after this.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("By the time they got back to park the convertible near the Eiffel Tower, they were both eager to go up to see the setting sun and the turning on of the lights of Paris.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Just don’t forget to put up the top,” Sadie said as she leaned back to look at her adorable pets.  “Gee,” she told Palmer.  “I don’t even have to tell them to be good.  They’re already tuckered out.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Palmer put the top up, locked the doors and off they went.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With their reservation secured, they by-passed the long line and were able to get into the very next elevator.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“This is so cool,” Sadie said as she watched the whole of Paris come into view.  “It’s magical.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They arrived at the top just in time to watch the spectacle of the sun reaching the horizon and the many twinkling lights of the city turning on.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There certainly is something magical about this city,” Palmer said.  “And I’m glad I get to experience this magic with you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, Palmer,” Sadie said.  “You’re always so sweet.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They strolled around the promenade, pointing out various features of Paris, and twenty minutes later, they boarded the elevator down.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I have to admit that I hadn’t thought we’d spend so much time here in town and I didn’t reserve a room for the night,” Palmer said as they headed back to the car.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ah,” Sadie exclaimed, holding her finger up.  “Now, it’s my turn to say that I took care of that.  I reserved two rooms at the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chateau de la Rive Sud")]), _vm._v(".  It’s a wonderful old place, rich with history and full of character.  You’ll love it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They drove off and headed to the hotel where Sadie then put a leash on Biscuit and put a drowsy Orchid into her carrying case.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Here,” Palmer offered, holding his hand out to carry Orchid.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Thanks,” Sadie said as she grabbed her overnight bag.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The intricately carved double doors were heavy as she pushed into them to enter the lobby.  With its thick red carpeting lined with gold that bordered on tacky, the red, gold and black room was very elegant.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Bonsoir")]), _vm._v(", madame,” the clerk said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("“Bonsoir")]), _vm._v(", I reserved two rooms under the name of Sadie Silver.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The clerk busied himself finding her reservation in the computer system and getting the keys ready.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Voila,” he finally said as he handed her two sets of keys.  He gestured to the hall to the left.  “"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Les chambres trente-cinq et trente-trois.”")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("“Merci")]), _vm._v(",” Sadie said as she picked up the keys, picked up her little overnight bag and turned in the direction he’d indicated.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“This really is full of old world charm,” Palmer said as they found the elevator.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Orchid meowed loudly as the doors to the elevator slid noisily shut and it cranked its way up to the third floor.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So old, in fact,” Sadie said, “that they still use old fashioned keys.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They got off the elevator and Sadie looked to the left then the right.  “We have rooms thirty-five and thirty-three.  They should be that way.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Heading to the right, they soon came to room thirty-five.  But just as Sadie put the key in the keyhole and pushed the door open, the elevator doors opened down the hall.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mademoiselle Sadie,” a man called out.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She took a disappointed glance in the small room, then turned to face the dapper and handsome man who was rushing toward them.  “Yes.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Milles excuses")]), _vm._v(",” he said.  “My excuses... I mean apologies.  I am the General Manager of the Chateau, Maxwell Perrier.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh,” Sadie said, holding her hand out to shake his.  He was older, perhaps in his early forties, but he was spry and full of energy.  “What a pleasure to meet you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It is entirely my pleasure,” he said, gushing.  “When I saw that you, Sadie Silver, were coming to my humble establishment, I just knew that I had to take very good care of you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Paul-Emile gave you the keys to...?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie pointed to the door.  “Thirty-three and thirty-five.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well,” Max said.  “That will not do.  That will not do at all.  Here.”  He held out another set of keys.  “I want you to enjoy your stay with us, so please accept this upgrade as a token of our appreciation for choosing l"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("e Chateau de la Rive Gauche")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“An upgrade?” Sadie said, excited by the unexpected turn of events.  “How very generous of you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It is my pleasure.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie looked at the solitary set of keys and realized that she, alone, was getting the upgrade.  “Room sixty-seven.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The view of the Tour Eiffel is superb,” he said, kissing his pinched fingertips and sending the kiss off into the air.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well, thank you very much,” Sadie said.  She glanced apologetically at Palmer who smiled and shrugged, unperturbed by the change.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Suivez-moi")]), _vm._v(",” Max said, gesturing to the elevator.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They followed him with Biscuit running up ahead of the man and nearly tripping him over.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Ah, mais qu’il est adorable")]), _vm._v(",” Max said, patting Biscuit on the head as they all boarded the elevator.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” Sadie said as she looked down at her excited pup.  “He is quite adorable... and a little rambunctious at times.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That is to be expected.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The elevator brought them up two floors higher and they all got out.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Just over here,” Max said, leading them to the left.  At the door, he gestured for the key which Sadie handed him.  “No,” he said.  “This one is for the door downstairs.  The other one is for your room.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She handed him the other key.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That’s right.”  He turned and unlocked the door, then handed the key back to her.  “And here you are,” he said as he pushed the door open.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, Monsieur Perrier,” Sadie said as she looked at the elaborately decorated room.  While still retaining a lot of the old world charm with its Louix XVI furnishings, the white-washed finishes were modern as were the linens and draperies.  The total effect was glamorous and chic.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Please, please, please,” Max said.  “Call me Max.  Monsieur Perrier makes me feel so ancient.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie chuckled.  “All right, then, Max.  This is perfect.  Thank you.  It’s more than I could have ever asked for.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Once again,” Max said.  “It is my pleasure to have you at my hotel.  My honor.  I am a great fan of your desserts.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well then, I’ll be sure to have something special sent over just for you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I would enjoy that.  And while we are on the topic of food... may I suggest the filet mignon with "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pomme de terre en purée")]), _vm._v(" for dinner?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh,” Sadie said, suddenly realizing just how hungry she was.  “That sounds yummy.  My friend will stay with me for dinner.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tres bien")]), _vm._v(".”  Max bowed then backed out of the room.  “Dinner for two... coming up.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wow,” Palmer said after Max closed the door.  “This is quite an upgrade.”  He headed to the window and pushed back the curtain.  “Look at that.  Now, that is a view.  You have the Eiffel Tower right there.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie came up beside him.  “It is beautiful, isn’t it?  Wow.  What an unexpected surprise.”  She then let Orchid out of the carrying bag and unleased Biscuit.  Orchid quickly jumped up onto the windowsill while Biscuit did his usual sniff around the unfamiliar room.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Even your feline friend enjoys this view,” Palmer said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You like it here, Orchid?” Sadie said, running her finger under Orchid’s chin.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Purring, Orchid closed her eyes, enjoying the attention.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m really sorry he didn’t offer you an upgrade,” Sadie said to Palmer.  “Maybe I should have asked him.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Don’t worry about that,” Palmer said.  “I’m happy no matter what room I get.  So long as there’s a bed, I’m fine.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well, you will stay with me to have dinner, won’t you?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Of course,” he said.  “I wouldn’t miss a perfectly cooked filet mignon with pureed potatoes for anything.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Good,” Sadie said with a laugh.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She pulled a few things from her overnight bag.  She brought her toiletries to the bathroom and set her clothes out in the closet.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I was thinking of going to Le Louvre tomorrow,” Sadie said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sounds good.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And you can look into what else you would like to see while we’re here.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ll do that.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A knock at the door sounded and Sadie hurried to open the door.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mademoiselle Sadie,” the woman said as she pushed a cart inside.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hello,” Sadie said, looking at the two trays on the cart.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“My name is Charlotte Monet, and I am the hotel chef and I wanted to personally come up to serve you this sumptuous meal.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It certainly smells divine,” Sadie said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The thirty something woman had her blond hair pulled back into a tight chignon, and even with her chef’s jacket covering her clothes, there was an air of sophistication about her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Behind her, a young twenty-something came in carrying a tray.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hello, hello,” the chipper young woman said.  With jet black hair pinned up in a very loose bun, the curvaceous woman smiled at Sadie then looked at Palmer with a flirtatious grin.  “And I am Pamela Dubois, the pastry chef here at the Chateau.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie smiled, but before she could say anything, Max walked in.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I do hope it’s not an imposition,” he said, “but...”  He looked at the cart and tray.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Truth is,” Pamela said.  “We’re dying to know what you think.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What I think?” Sadie said, not quite understanding her meaning.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“People are always complimenting my food,” Charlotte said.  “But many people know nothing about fine cuisine.  I just wanted... well, a world-renown... celebrity...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie smiled.  “It would be my pleasure to give you my opinion.”  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She picked up one of the plates and brought it to the elegant little table set up in the corner flanked by two Louis XVI chairs.  She pulled the plate cover off the plate and her mouth instantly watered as the rich aromas of mushrooms in wine sauce reached her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh,” she said.  “I can already tell that this is going to be good.”  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She picked up the fork and steak knife and cut off a generous bite.  Using her knife, she covered the steak with the mushroom sauce then dipped it into the rich and creamy pureed potatoes.  Sincerely hoping that it would taste as good as it smelled, she took the bite.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The flavors filled her mouth, covered her tongue and palate.  She let the flavors settle in, seep in and truly touch every part of her tongue as she tried to pick out the various herbs Charlotte had used.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The steak is just how I like it, medium rare,” Sadie said, realizing that Max had not asked how she wanted it cooked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Good,” Charlotte said.  “In my opinion, that is the only way a steak should be cooked.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The potatoes are divine.  I’m trying to find what...”  She took another small bite of just potatoes.  “Onions?  Garlic?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Caramelized onions,” Charlottes said.  “And a few secret herbs, of course.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Heaven,” Sadie said.  “And this sauce.  I love a good wine sauce, but some people tend to go overboard, thinking the more wine the put the better.  But this is just perfectly balanced.  I love it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I know it’s a little unorthodox,” Pamela said.  “But I would love to have your take on my pastry.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Certainly,” Sadie said.  She took a good swig of water to rinse out her mouth, then took a look at what Pamela had brought.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s my version of a "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("petit chou")]), _vm._v(" filled with soft caramel and topped with a thin layer of Italian meringue.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hmm,” Sadie said as she picked up the small ball with her fingers and examined it.  “How interesting.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She took a bite and rolled her eyes to the heavens.  “Oh, Lordy,” she said with a smile.  “I’m not quite sure how you managed to pull this off, but it is fabulous.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Pamela clapped her hands excitedly.  “Oh, good.  I’m so happy.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well,” Max said as he tapped the two women on the shoulder.  “We won’t impose on you any further.  Please, enjoy your meal.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He led Charlotte and Pamela out and closed the door behind them.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Is it really that good?” Palmer said as he took his plate and settled at the table.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Better,” Sadie said as she once again rinsed out her mouth.  “I could eat this every night.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Palmer dug in and nodded in agreement.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Biscuit sat patiently at Sadie’s feet, glancing up at her every time she took a bite.  Orchid sat at the foot of the bed, purr/meowing her desire to have a taste.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie looked at her quickly disappearing steak.  “I don’t know if I’m going to be able to share this with you guys.  It’s just too darn good.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Biscuit looked at her with a pleading yelp.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh.  All right.”  She cut off two small pieces and gave one to Biscuit then reached out to give the other piece to Orchid.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You spoil them too much,” Palmer said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I know, but they spoil me, too.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Constantly sighing their appreciation of every bite, they ate their steaks and then attacked the dessert.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wow,” Palmer said after taking a bite.  “I think you might have some stiff competition here.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Right.  I might have to up my game.”  Sadie finished her dessert, savoring every bite.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Do you think I could go back down and ask for seconds?” Palmer said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m sure she’d be pleased with that,” Sadie said as she got up and looked around the room.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What are you looking for?” Palmer said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Where’s that box of pastries I picked up at my shop?  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s just there by the credenza,” Palmer said.  “Are you still hungry after all this?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, silly,” Sadie said as she made her way to the credenza.  “I don’t know why I didn’t think to offer it to them when they came up, but...  I was thinking of bringing this down to the staff as a thank you for the great meal.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I think they’d really appreciate that,” Palmer said.  He took the last bite of his dessert and licked his fingers.  “Want me to come along with you?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sure,” Sadie said.  “I want to bring Biscuit down too and maybe take him on a short walk before coming back up.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Palmer got up, ready to follow her out.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Do you want to come, too, Orchid?” Sadie said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Orchid looked at her then abruptly turned to go settle on the bed between the two pillows.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“All right then,” Sadie said.  “See you later.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With her box of pastries in hand and Biscuit at her heel, she headed out behind Palmer.  They rode the elevator down and reached the nearly empty lobby.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Look,” Sadie said, seeing the small sign indicating the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("salle a manger")]), _vm._v(".  “The dining room is down that way.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They headed down the corridor and reached the dining room.  A lone couple seated in a far corner sipping wine were the only customers.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Come on,” Sadie said.  “We’ll sneak into the kitchen.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She led the way through the small dining room and pushed open the door to the kitchen.  The light was on, but no one was around.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“They just made us dinner barely twenty minutes ago,” Palmer said.  “Now they’re all gone?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie shrugged.  “"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Allo")]), _vm._v("?” she called out.  “Is anybody here?  Miss Charlotte?  Pamela?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("No answer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Biscuit suddenly bolted away from her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wait!” Sadie called out.  “Biscuit.  Wait for me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She caught up with him and found him seated before the large and heavy door to the walk-in freezer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Palmer and Sadie exchanged glances.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Do you think he just smells the steaks in there?” Palmer said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I hope that’s all he smells,” Sadie said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Palmer reached out to the large handle to the freezer, but hesitated. Sadie nodded, urging him to open the door.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He pulled on the lever and opened the door.  Biscuit quickly ran inside.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie and Palmer stood there for a startled second, staring in disbelief.  Chef Dubois, her back to them, stood in the center of the freezer, pinned to a large side of beef with an icepick.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, my God,” Sadie said, recovering from the initial shock.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She ran up to the young, curvaceous woman and walked around her to look at her face.  Though it was clear that she was dead, she nonetheless reached for her wrist, hoping beyond hope for a pulse.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ca73a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 69
// module chunks = 0